import React from "react";
import "./OpenBets.css"; // Include the CSS in a separate file or use inline styles
import "../../../src/App.css";
import Header from "../header/Header";
import Footer from "../Footer/Footer";
import { CiSearch } from "react-icons/ci";
import 'bootstrap/dist/css/bootstrap.min.css';
import { getAllBets } from '../../redux/slice/openBet/openBetSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import Appconfig from '../../config/config';
import axios from 'axios';
import Helper from "../../helper";
import {
  useNavigate,
  useLocation
} from "react-router-dom";
// import { Table } from "antd";
import ExposureHeader from '../ExposureHeader/ExposureHeader';
import ScrollGames from "../ScrollGames/ScrollGames";
import SideMenu from "../SideMenu/SideMenu";
import { Outlet } from "react-router-dom";

function OpenBets(props) {
  const navigate = useNavigate();

  const location = useLocation();

  /*
   * Delete functionality sirf dedicated
   * Open Bets page par visible hogi.
   *
   * MatchUpdates/sidebar me OpenBets component
   * reuse hone par controls hidden rahenge.
   */
  const showDeleteControls =
    location.pathname === "/openbets" ||
    location.pathname.startsWith(
      "/openbets/"
    );

  const dispatch = useDispatch();
  const userInfo = Helper(); // get login user details
  const openbets = useSelector((state) => state.bets); // Use selector to access state
  const [fancyBets, setFancyBets] = useState([]);
  const [matchBets, setMatchBets] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  // console.log('matchBets', matchBets);
  // console.log('fancyBets', fancyBets);
  const [showMenu, setShowMenu] = useState(false); // <-- Add this
  // Handler to toggle menu
  const handleToggleMenu = () => setShowMenu((prev) => !prev);
  const [eventType, setEventType] = useState(undefined); // or your default

  /*
 * Bet void/delete frontend password.
 * Backend routes/betting.js wale password ke
 * exactly same hona chahiye.
 */
  const BET_VOID_PASSWORD = "Delete@2026";

  /*
   * Selected bet IDs.
   */
  const [
    selectedBetIds,
    setSelectedBetIds
  ] = useState([]);

  /*
   * Password confirmation modal.
   */
  const [
    showDeleteModal,
    setShowDeleteModal
  ] = useState(false);

  const [
    deletePassword,
    setDeletePassword
  ] = useState("");

  const [
    deleteReason,
    setDeleteReason
  ] = useState(
    "Deleted by user"
  );

  const [
    isDeletingBets,
    setIsDeletingBets
  ] = useState(false);

  const [
    deleteError,
    setDeleteError
  ] = useState("");

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getOpenBetsByEvent =
    async () => {
      if (!userInfo?._id) {
        return;
      }

      return dispatch(
        getAllBets({
          user_id:
            String(userInfo._id)
        })
      );
    };

  useEffect(() => {
    if (userInfo?._id) {
      getOpenBetsByEvent();
    }
  }, [userInfo?._id]);

  useEffect(() => {
    const openBetsData =
      Array.isArray(openbets?.bets)
        ? openbets.bets
        : [];

    /*
     * Sirf currently Open, non-deleted aur
     * non-cancelled bets UI me show karo.
     */
    const validOpenBets =
      openBetsData.filter((bet) => {
        const status =
          String(
            bet?.status || "Open"
          ).toLowerCase();

        const isDeleted =
          String(
            bet?.is_delete || "No"
          ).toLowerCase() === "yes";

        const isCancelled =
          String(
            bet?.is_cancel || "No"
          ).toLowerCase() === "yes";

        return (
          status === "open" &&
          !isDeleted &&
          !isCancelled
        );
      });

    setFancyBets(
      validOpenBets.filter(
        (bet) =>
          bet?.betting_type ===
          "Fancy"
      )
    );

    setMatchBets(
      validOpenBets.filter(
        (bet) =>
          bet?.betting_type ===
          "Match"
      )
    );

    /*
     * Refresh ke baad jo selected IDs list me
     * nahi hain unhe selection se remove karo.
     */
    const currentOpenIdSet =
      new Set(
        validOpenBets
          .map((bet) =>
            String(
              bet?._id ||
              bet?.betting_id ||
              ""
            )
          )
          .filter(Boolean)
      );

    setSelectedBetIds(
      (previousIds) =>
        previousIds.filter(
          (betId) =>
            currentOpenIdSet.has(
              betId
            )
        )
    );
  }, [openbets]);

  const columns = [
    {
      title: 'Event Name',
      dataIndex: 'event_name',
      sorter: true,
      render: (_, record) => (
        <>
          <span>{record?.event_name}</span>
        </>
      ),
    },
    {
      title: 'Market Type',
      dataIndex: 'market_name',
      sorter: true,
      render: (_, record) => (
        <>
          <span>{record?.market_name}</span>
        </>
      ),
    },
    {
      title: 'Selection',
      dataIndex: 'runner_name',
      sorter: true,
      render: (_, record) => (
        <>
          <span>{record?.runner_name}</span>
        </>
      ),
    },
    {
      title: 'Bet Type',
      dataIndex: 'is_back',
      sorter: true,
      render: (_, record) => (
        <>
          <span>{record?.is_back ? 'Back' : 'Lay'}</span>
        </>
      ),
    },
    {
      title: 'Stack',
      dataIndex: 'stake',
      sorter: true,
      render: (_, record) => (
        <>
          <span>{record?.stake}</span>
        </>
      ),
    },

    {
      title: 'Round ID',
      dataIndex: 'betting_id',
      sorter: true,
      render: (_, record) => (
        <>
          <span>{record?._id}</span>
        </>
      ),
    },
    {
      title: 'Place Time',
      dataIndex: 'createdAt',
      sorter: true,
      render: (_, record) => (
        <>
          <span>
            {new Date(record?.createdAt).toLocaleString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
            })}
          </span>
        </>
      ),
    },
  ];


  const columnFancy = [
    {
      title: 'Event Name',
      dataIndex: 'name',
      sorter: true,
      render: (_, record) => (
        <>
          <span>{record?.event_name}</span>
        </>
      ),
      width: '20%',
    },
    {
      title: 'Market Type',
      dataIndex: 'name',
      sorter: true,
      render: (_, record) => (
        <>
          <span>{record?.market_name}</span>
        </>
      ),
      width: '20%',
    },
    {
      title: 'Selection',
      dataIndex: 'name',
      sorter: true,
      render: (_, record) => (
        <>
          <span>{record?.runner_name}</span>
        </>
      ),
      width: '20%',
    },
    {
      title: 'Bet Type',
      dataIndex: 'name',
      sorter: true,
      render: (_, record) => (
        <>
          <span>{record?.is_back ? 'Back' : 'Lay'}</span>
        </>
      ),
      width: '20%',
    },
    {
      title: 'Stack',
      dataIndex: 'name',
      sorter: true,
      render: (_, record) => (
        <>
          <span>{record?.stake}</span>
        </>
      ),
      width: '20%',
    },

    {
      title: 'Round ID',
      dataIndex: 'name',
      sorter: true,
      render: (_, record) => (
        <>
          <span>{record?._id}</span>
        </>
      ),
      width: '20%',
    },
    {
      title: 'Place Time',
      dataIndex: 'name',
      sorter: true,
      render: (_, record) => (
        <>
          <span>
            {new Date(record?.createdAt).toLocaleString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
            })}
          </span>
        </>
      ),
      width: '20%',
    },
  ];

  const allMatchedBets = [
    ...(Array.isArray(matchBets) ? matchBets : []),
    ...(Array.isArray(fancyBets) ? fancyBets : []),
  ];

  const isFancyOpenBet = (bet) => {
    const rawFancy =
      bet?.is_fancy ??
      bet?.isFancy ??
      bet?.betting_type ??
      bet?.market_type ??
      bet?.market_name;

    const normalizedFancy = String(rawFancy)
      .trim()
      .toLowerCase();

    return (
      rawFancy === true ||
      rawFancy === 1 ||
      normalizedFancy === "1" ||
      normalizedFancy === "yes" ||
      normalizedFancy === "true" ||
      normalizedFancy === "fancy" ||
      normalizedFancy === "session" ||
      normalizedFancy.includes("fancy") ||
      normalizedFancy.includes("session")
    );
  };

  const getBetSide = (bet) => {
    const rawSide =
      bet?.is_back ??
      bet?.isBack ??
      bet?.bet_type ??
      bet?.betType ??
      bet?.side ??
      bet?.type;

    const normalizedSide = String(rawSide)
      .trim()
      .toLowerCase();

    let baseSide = "lay";

    if (
      rawSide === true ||
      rawSide === 1 ||
      normalizedSide === "1" ||
      normalizedSide === "back" ||
      normalizedSide === "yes" ||
      normalizedSide === "true"
    ) {
      baseSide = "back";
    } else if (
      rawSide === false ||
      rawSide === 0 ||
      normalizedSide === "0" ||
      normalizedSide === "lay" ||
      normalizedSide === "no" ||
      normalizedSide === "false"
    ) {
      baseSide = "lay";
    }

    /*
     * Fancy API ka Back/Lay mapping normal markets se opposite hai.
     * Sirf display colour reverse karna hai.
     */
    if (isFancyOpenBet(bet)) {
      return baseSide === "back"
        ? "lay"
        : "back";
    }

    return baseSide;
  };

  const getBetName = (bet) => {
    return (
      bet?.runner_name ||
      bet?.selection_name ||
      bet?.market_name ||
      bet?.event_name ||
      "-"
    );
  };

  const getBetOdds = (bet) => {
    const value =
      bet?.price_val ??
      bet?.price ??
      bet?.odds ??
      bet?.rate ??
      bet?.bet_rate;

    return value !== undefined &&
      value !== null &&
      value !== ""
      ? value
      : "-";
  };

  const getBetStake = (bet) => {
    const value =
      bet?.stake ??
      bet?.stack ??
      bet?.amount ??
      bet?.bet_amount;

    return value !== undefined &&
      value !== null &&
      value !== ""
      ? value
      : "-";
  };

  /*
 * Sirf valid database IDs wali Open bets
 * select ki ja sakti hain.
 */
  const selectableBetIds =
    allMatchedBets
      .filter((bet) => {
        const betId =
          bet?._id ||
          bet?.betting_id;

        const betStatus =
          String(
            bet?.status || "Open"
          ).toLowerCase();

        return (
          betId &&
          betStatus === "open"
        );
      })
      .map((bet) =>
        String(
          bet?._id ||
          bet?.betting_id
        )
      );

  /*
   * Single bet select/unselect.
   */
  const handleBetSelection = (
    betId
  ) => {
    const normalizedBetId =
      String(betId || "");

    if (!normalizedBetId) {
      return;
    }

    setSelectedBetIds(
      (previousIds) => {
        if (
          previousIds.includes(
            normalizedBetId
          )
        ) {
          return previousIds.filter(
            (id) =>
              id !== normalizedBetId
          );
        }

        return [
          ...previousIds,
          normalizedBetId
        ];
      }
    );
  };

  /*
   * All visible open bets select/unselect.
   */
  const handleSelectAllBets = () => {
    const allSelected =
      selectableBetIds.length > 0 &&
      selectableBetIds.every(
        (betId) =>
          selectedBetIds.includes(
            betId
          )
      );

    if (allSelected) {
      setSelectedBetIds([]);
      return;
    }

    setSelectedBetIds(
      selectableBetIds
    );
  };

  /*
   * Password modal open.
   */
  const handleOpenDeleteModal = () => {
    if (
      selectedBetIds.length === 0
    ) {
      setDeleteError(
        "Please select at least one bet"
      );
      return;
    }

    setDeleteError("");
    setDeletePassword("");
    setDeleteReason(
      "Deleted by user"
    );
    setShowDeleteModal(true);
  };

  /*
   * Password modal close.
   */
  const handleCloseDeleteModal = () => {
    if (isDeletingBets) {
      return;
    }

    setShowDeleteModal(false);
    setDeletePassword("");
    setDeleteError("");
  };

  const handleVoidSelectedBets =
    async () => {
      setDeleteError("");

      /*
       * Frontend hardcoded password validation.
       */
      if (
        deletePassword !==
        BET_VOID_PASSWORD
      ) {
        setDeleteError(
          "Invalid delete password"
        );
        return;
      }

      if (
        selectedBetIds.length === 0
      ) {
        setDeleteError(
          "Please select at least one bet"
        );
        return;
      }

      if (!userInfo?._id) {
        setDeleteError(
          "User information not found"
        );
        return;
      }

      try {
        setIsDeletingBets(true);

        const response =
          await axios.post(
            `${Appconfig.apiUrl}betting/voidSelectedOpenBets`,
            {
              user_id:
                String(userInfo._id),

              password:
                deletePassword,

              bet_ids:
                selectedBetIds,

              reason:
                deleteReason.trim() ||
                "Deleted by user"
            },
            {
              headers: {
                "Content-Type":
                  "application/json"
              }
            }
          );

        if (
          response?.data?.result !== 1
        ) {
          setDeleteError(
            response?.data
              ?.resultMessage ||
            "Unable to delete selected bets"
          );
          return;
        }

        const resultData =
          response?.data
            ?.resultData || {};

        /*
         * Selection aur modal reset.
         */
        setSelectedBetIds([]);
        setShowDeleteModal(false);
        setDeletePassword("");
        setDeleteError("");

        /*
         * Redux se latest open bets reload.
         */
        await getOpenBetsByEvent();

        /*
         * Balance header ko refresh signal.
         * Iska listener baad me ExposureHeader me add karenge.
         */
        window.dispatchEvent(
          new CustomEvent(
            "open-bets-voided",
            {
              detail: resultData
            }
          )
        );

        window.alert(
          "Selected bets deleted successfully.\n" +
          "Voided bets: " +
          (
            resultData.voided_count ||
            selectedBetIds.length
          ) +
          "\nReleased amount: ₹" +
          Number(
            resultData.released_amount ||
            0
          ).toFixed(2)
        );
      } catch (error) {
        console.error(
          "VOID SELECTED BETS ERROR:",
          error
        );

        setDeleteError(
          error?.response?.data
            ?.resultMessage ||
          error?.message ||
          "Unable to delete selected bets"
        );
      } finally {
        setIsDeletingBets(false);
      }
    };

  // if (isMobile){
  if (!userInfo) {
    // Not logged in: show the sidebar code
    return (
      <aside
        title="Menu2"
        id="rightDeskSideBar"
        className="lg:flex p-0 overflow-y-auto sticky top-0 h-[calc(100vh-110px)]"
        style={{ maxWidth: "350px" }}
      >
        <div style={{ width: "350px" }} className="flex p-2 overflow-x-hidden relative no-scrollbar border flex-col rounded-lg bg-bg_color_primary" >
          <div className="w-full flex flex-col gap-y-1 py-2">
            <div className="w-full flex items-center gap-1">
              <div className="flex gap-1 w-3/4 rounded-lg p-0.5 border">
                <button className="text-xs w-full capitalize whitespace-nowrap rounded p-2 bg-bg_color_primary text-black">
                  Betslip
                </button>
                <button className="text-xs w-full capitalize whitespace-nowrap rounded p-2 bg-bg_brand_secondary text-text_color_primary2">
                  Open Bets
                </button>
              </div>
            </div>
            <h4 className="text-sm font-lato text-center py-4 text-text_color_primary1 font-normal">
              Please login to see your open bets.
              <span className="bg-bg_text_brand_primary bg-clip-text text-transparent cursor-pointer hover:underline">
                Login
              </span>
            </h4>
          </div>
        </div>
      </aside>
    );
  }
  // }


  return (
    <section
      className={[
        "reference-my-bets",
        showDeleteControls
          ? "reference-delete-mode"
          : ""
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="reference-my-bets-title">
        <span>My Bet</span>

        {showDeleteControls &&
          selectableBetIds.length > 0 && (
            <span className="reference-selected-count">
              {selectedBetIds.length} selected
            </span>
          )}
      </div>

      {showDeleteControls &&
        selectableBetIds.length > 0 && (
          <div className="reference-bet-actions">

            <label className="reference-select-all">
              <input
                type="checkbox"
                checked={
                  selectableBetIds.length > 0 &&
                  selectableBetIds.every(
                    (betId) =>
                      selectedBetIds.includes(
                        betId
                      )
                  )
                }
                onChange={
                  handleSelectAllBets
                }
                disabled={
                  isDeletingBets
                }
              />

              <span>Select All</span>
            </label>

            <button
              type="button"
              className="reference-delete-bets-button"
              onClick={
                handleOpenDeleteModal
              }
              disabled={
                selectedBetIds.length === 0 ||
                isDeletingBets
              }
            >
              Delete Selected
              {selectedBetIds.length > 0
                ? ` (${selectedBetIds.length})`
                : ""}
            </button>

          </div>
        )}

      <div className="reference-my-bets-table">
        <div className="reference-my-bets-head">
          {showDeleteControls && (
            <strong className="reference-select-column">
              Select
            </strong>
          )}

          <strong>Matched Bet</strong>
          <strong>Odds</strong>
          <strong>Stake</strong>
        </div>

        <div className="reference-my-bets-body">
          {allMatchedBets.map(
            (bet, index) => {
              const betSide =
                getBetSide(bet);

              const betId =
                String(
                  bet?._id ||
                  bet?.betting_id ||
                  ""
                );

              const betStatus =
                String(
                  bet?.status || "Open"
                ).toLowerCase();

              const isSelectable =
                Boolean(betId) &&
                betStatus === "open";

              const isSelected =
                selectedBetIds.includes(
                  betId
                );

              return (
                <div
                  key={
                    betId ||
                    `${getBetName(bet)}-${index}`
                  }
                  className={[
                    "reference-my-bet-row",

                    betSide === "lay"
                      ? "reference-my-bet-lay"
                      : "reference-my-bet-back",

                    isSelected
                      ? "reference-my-bet-selected"
                      : "",

                    !isSelectable
                      ? "reference-my-bet-disabled"
                      : ""
                  ]
                    .filter(Boolean)
                    .join(" ")}
                >
                  {showDeleteControls && (
                    <span className="reference-bet-checkbox">
                      <input
                        type="checkbox"
                        checked={
                          isSelected
                        }
                        disabled={
                          !isSelectable ||
                          isDeletingBets
                        }
                        onChange={() =>
                          handleBetSelection(
                            betId
                          )
                        }
                        aria-label={
                          `Select ${getBetName(
                            bet
                          )} bet`
                        }
                      />
                    </span>
                  )}

                  <span
                    className="reference-my-bet-name"
                    title={
                      getBetName(bet)
                    }
                  >
                    {getBetName(bet)}
                  </span>

                  <span className="reference-my-bet-odds">
                    {getBetOdds(bet)}
                  </span>

                  <span className="reference-my-bet-stake">
                    {getBetStake(bet)}
                  </span>
                </div>
              );
            }
          )}
        </div>

        {showDeleteControls &&
          showDeleteModal && (
            <div
              className="reference-delete-modal-overlay"
              onClick={
                handleCloseDeleteModal
              }
            >
              <div
                className="reference-delete-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="delete-bets-title"
                onClick={(event) =>
                  event.stopPropagation()
                }
              >
                <div className="reference-delete-modal-header">
                  <div>
                    <h3 id="delete-bets-title">
                      Delete Selected Bets
                    </h3>

                    <p>
                      {selectedBetIds.length} bet
                      {selectedBetIds.length === 1
                        ? ""
                        : "s"}{" "}
                      selected
                    </p>
                  </div>

                  <button
                    type="button"
                    className="reference-delete-modal-close"
                    onClick={
                      handleCloseDeleteModal
                    }
                    disabled={
                      isDeletingBets
                    }
                    aria-label="Close"
                  >
                    ×
                  </button>
                </div>

                <div className="reference-delete-modal-body">

                  <div className="reference-delete-warning">
                    Selected bets will be voided and their
                    net exposure will be released back to
                    the available balance.
                  </div>

                  <div className="reference-delete-field">
                    <label htmlFor="bet-delete-password">
                      Delete Password
                    </label>

                    <input
                      id="bet-delete-password"
                      type="password"
                      value={
                        deletePassword
                      }
                      onChange={(event) => {
                        setDeletePassword(
                          event.target.value
                        );

                        if (deleteError) {
                          setDeleteError("");
                        }
                      }}
                      onKeyDown={(event) => {
                        if (
                          event.key === "Enter" &&
                          !isDeletingBets
                        ) {
                          handleVoidSelectedBets();
                        }
                      }}
                      placeholder="Enter delete password"
                      autoComplete="off"
                      disabled={
                        isDeletingBets
                      }
                      autoFocus
                    />
                  </div>

                  <div className="reference-delete-field">
                    <label htmlFor="bet-delete-reason">
                      Reason
                    </label>

                    <textarea
                      id="bet-delete-reason"
                      value={
                        deleteReason
                      }
                      onChange={(event) =>
                        setDeleteReason(
                          event.target.value
                        )
                      }
                      placeholder="Enter reason"
                      maxLength={250}
                      rows={3}
                      disabled={
                        isDeletingBets
                      }
                    />
                  </div>

                  {deleteError && (
                    <div className="reference-delete-error">
                      {deleteError}
                    </div>
                  )}

                </div>

                <div className="reference-delete-modal-footer">
                  <button
                    type="button"
                    className="reference-delete-cancel-button"
                    onClick={
                      handleCloseDeleteModal
                    }
                    disabled={
                      isDeletingBets
                    }
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="reference-delete-confirm-button"
                    onClick={
                      handleVoidSelectedBets
                    }
                    disabled={
                      isDeletingBets ||
                      !deletePassword.trim()
                    }
                  >
                    {isDeletingBets
                      ? "Deleting..."
                      : "Confirm Delete"}
                  </button>
                </div>
              </div>
            </div>
          )}
      </div>
    </section>
  );
}

export default OpenBets;
